import { useEffect } from 'react';

/**
 * Puts the viewport at the top of a registration step once that step's content is on screen.
 *
 * App scrolls to top on pathname change, but these steps paint a loading state first, so that
 * scroll lands before the form exists. It holds today only because the loading state leaves the
 * page too short to scroll, which stops being true as soon as a step keeps its height.
 *
 * @param contentVisible false while the step renders a loading state instead of its content
 */
export function useScrollToStepTop(contentVisible = true) {
  useEffect(() => {
    if (contentVisible) {
      window.scrollTo(0, 0);
    }
  }, [contentVisible]);
}
